var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSidenavArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFEFDB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4939 15.4478L18.7905 10.0668C18.4788 9.60969 17.9746 9.3335 17.4338 9.3335C16.0679 9.3335 15.2796 10.9335 16.0679 12.0859L18.7538 16.0002L16.0679 19.9144C15.2704 21.0668 16.0679 22.6668 17.4338 22.6668C17.9746 22.6668 18.488 22.3906 18.7997 21.9335L22.5031 16.5525C22.7231 16.2192 22.7231 15.7811 22.4939 15.4478Z",
    fill: "#FFAD49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0769 15.4478L12.3827 10.0668C12.0618 9.60969 11.5576 9.3335 11.0168 9.3335C9.65093 9.3335 8.85341 10.9335 9.65093 12.0859L12.3368 16.0002L9.65093 19.9144C8.85341 21.0668 9.65093 22.6668 11.0168 22.6668C11.5576 22.6668 12.071 22.3906 12.3827 21.9335L16.0861 16.5525C16.3061 16.2192 16.3061 15.7811 16.0769 15.4478Z",
    fill: "#FFAD49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSidenavArrow);
export default __webpack_public_path__ + "static/media/right-sidenav-arrow.82618ff886de41b12238012f5fc1bd20.svg";
export { ForwardRef as ReactComponent };